import { Box } from "@mui/material";
import { LabelValue } from "@zfp-akademie-a-s/zfp-design";
import { Spacing } from "Infrastructure/Themes/Themes";
import { alignWithGoalName } from "./GoalCardHeader";
import type { GoalCardFact } from "./utils/goalCardFacts";

type Props = {
  facts: GoalCardFact[];
  isCompleted: boolean;
  isTablet: boolean;
};

export const GoalCardFacts = ({ facts, isCompleted, isTablet }: Props) => (
  // the values inherit the colour, a completed goal's are muted; LabelValue keeps its labels secondary
  <Box
    display="grid"
    gridTemplateColumns={isTablet ? "minmax(0, 1fr)" : "repeat(2, minmax(0, 1fr))"}
    columnGap={Spacing.XL}
    rowGap={Spacing.L}
    color={isCompleted ? "text.secondary" : "text.primary"}
    sx={(theme) => ({ pl: alignWithGoalName(theme) })}
  >
    {facts.map(({ label, value }) => (
      <LabelValue key={label} label={label} value={value} />
    ))}
  </Box>
);
